import { useParams } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import { useGetTurnoverByIdQuery } from "../../../services/bClientApi"
import TurnoverEntry from "../../../Components/Turnover/TurnoverEntry/TurnoverEntry"
import DataLogList from "../../../Components/DataLogs/DataLogList"

export default function TurnoverPage() {
    const { turnoverId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetTurnoverByIdQuery(turnoverId, { skip: !turnoverId })
    const turnoverData = data || {}

    return (
        <Container>
            <Row>
                <Col
                    xs={12}
                    lg={9}
                >
                    <h1>Turnover Details</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {turnoverId && turnoverData && turnoverData._id && !isLoading && (
                        <TurnoverEntry
                            turnoverData={turnoverData}
                            fullView={true}
                        />
                    )}
                </Col>

                <Col
                    xs={12}
                    lg={3}
                >
                    <DataLogList
                        dataType="turnover"
                        dataId={turnoverId}
                    />
                </Col>
            </Row>
        </Container>
    )
}
